import { MovableInkBlock } from '../types';

export const mockFileName = 'mockFile.png';
export const mockNaturalHeight = 200;
export const mockNaturalWidth = 100;
export const fileBase64String = 'R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'; // a single pixel gif
export const fileDataUrl = `data:image/gif;base64,${fileBase64String}`;

export const mockBlocks: MovableInkBlock[] = [
  {
    aHref: '',
    campaignId: 12345,
    created: '2023-09-18T17:09:10.956Z',
    embedCode:
      '<img alt="Display images to show real-time content" style="border: 0; display: block;" border="0" src="https://www.ink1000.com/p/rp/1aec5cb267040b21.png?mi_u={{userId}}&mi_ign={{campaignId}}&Name=James&City=Austin" />',
    id: 101,
    imageUrl:
      'https://www.ink1000.com/p/rp/1aec5cb267040b21.png?mi_u={{userId}}&mi_ign={{campaignId}}&Name=James&City=Austin',
    name: 'treasure chest',
    updated: '2023-09-19T17:09:10.956Z',
    altText: 'alt text here',
  },
  {
    aHref:
      'https://www.ink1000.com/p/cp/759f13216fd0b6bb/c?mi_u={{userId}}&mi_ign={{campaignId}}&Name=James&url=http%3A%2F%2Fwww.ink1000.com%2Fp%2Frp%2F3235194675659886%2Furl&url_sig=052vAScI2Mnvuz',
    campaignId: 67890,
    created: '2023-09-16T17:09:10.956Z',
    embedCode:
      '<a href="https://www.ink1000.com/p/cp/759f13216fd0b6bb/c?mi_u={{userId}}&mi_ign={{campaignId}}&Name=James&url=http%3A%2F%2Fwww.ink1000.com%2Fp%2Frp%2F3235194675659886%2Furl&url_sig=052vAScI2Mnvuz" style="display: block"><img alt="Display images to show real-time content" style="border: 0; display: block;" border="0" src="https://www.ink1000.com/p/rp/3235194675659886.png?mi_u={{userId}}&mi_ign={{campaignId}}&Name=James" /></a>',
    id: 102,
    imageUrl:
      'https://www.ink1000.com/p/rp/3235194675659886.png?mi_u={{userId}}&mi_ign={{campaignId}}&Name=James',
    name: 'spooky cat',
    updated: '2023-09-17T17:09:10.956Z',
    altText: 'alt text here',
  },
];

export const mockSelectedBlock = {
  aHref: '',
  campaignId: 12345,
  created: '2023-09-18T17:09:10.956Z',
  embedCode:
    '<img alt="mockSelectedAsset desc" style="border: 0; display: block;" border="0" src="https://www.ink1000.com/p/rp/1aec5cb267040b21.png?mi_u={{userId}}&mi_ign={{campaignId}}&Name=James&City=Austin" />',
  id: 1,
  imageUrl: `https://example.com/${mockFileName}`,
  name: 'mock image',
  updated: '2023-09-19T17:09:10.956Z',
  altText: '',
};

export const mockSelectedEditorImageNode: Record<string, any> = {
  alt: 'mock alt text',
  height: mockNaturalHeight.toString(),
  naturalHeight: mockNaturalHeight,
  naturalWidth: mockNaturalWidth,
  src: `https://example.com/${mockFileName}`,
  style: '',
  width: mockNaturalWidth.toString(),
  getAttribute(attr: string) {
    return this[attr];
  },
  getAttributeNames() {
    return Object.keys(this);
  },
};

export const mockSelectedEditorAnchorNode: Record<string, any> = {
  href: `https://example.com`,
  style: '',
  getAttribute(attr: string) {
    return this[attr];
  },
  getAttributeNames() {
    return Object.keys(this);
  },
};
